/* eslint-disable import/prefer-default-export */
import axios from '../config/axios';
// MOMENTOS
export function consultarInformacionMomentoLlenos(encuentro_id, momento) {
  return new Promise((resolve, reject) => {
    axios.get('controlador_datos/encuentros/api/v1/formularios_llenos_momento', {
      params: {
        encuentro_id,
        momento,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}
export function consultarFormulariosMomentosLlenos(encuentro_id, momento) {
  return new Promise((resolve, reject) => {
    axios.get('/controlador_datos/encuentros/api/v1/cantidad_formularios_encuentro_y_momento', {
      params: {
        encuentro_id,
        momento,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}
export function formulariosLlenosPorTipoMomento(encuentro_id, momento, nombre_form) {
  return new Promise((resolve, reject) => {
    axios.get('/controlador_datos/encuentros/api/v1/formularios_llenos_encuentro_y_momento', {
      params: {
        encuentro_id,
        momento,
        nombre_form,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}

// ENCUENTROS

export function listaEncuentrosPorPaciente(documento) {
  return new Promise((resolve, reject) => {
    axios.get('/controlador_datos/encuentros/encuentros/api/v1/cantidad_encuentros_paciente_por_tipo', {
      params: {
        documento,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}


export function resumenEncuentrosPorTipo(documento, nombre, coleccion) {
  return new Promise((resolve, reject) => {
    axios.get(`/controlador_datos/encuentros/${coleccion}/api/v1/encuentros_paciente_por_tipo`, {
      params: {
        documento,
        nombre,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}
export function consultarInformacionMomentosEncuentro(encuentro) {
  return new Promise((resolve, reject) => {
    axios.get('/controlador_datos/encuentros/api/v2/consultar_momentos', {
      params: {
        encuentro,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}
export function consultarMarcacionesEncuentro(encuentro_id) {
  return new Promise((resolve, reject) => {
    axios.get('/controlador_datos/encuentros/api/v1/obtener_marcaciones', {
      params: {
        encuentro_id,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}
export function consultarTextoResumen(encuentro_id, coleccion) {
  return new Promise((resolve, reject) => {
    axios.get(`/controlador_datos/encuentros/${coleccion}/api/v1/obtener_text_resumen`, {
      params: {
        encuentro_id,
      },
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}
export async function agregarNotaEncuentro(encuentro_id, nota, creado_por, coleccion) {
  return await axios.patch(`/controlador_datos/encuentros/${coleccion}/api/v1/agregar_nota`, {
    encuentro_id,
    nota,
    creado_por,
  });
}
export async function prerrequisitos(coleccion, documento, creado_por, id) {
  return await axios.post('/consentimientos/prerrequisitos/api/v3/buscar', {
    coleccion,
    documento,
    creado_por,
    id,
  });
}



// WEBPACK FOOTER //
// ./src/apiService/request/CrudEncuentro.js